import React from 'react';
import WaterIntelQualityBadge from './WaterIntelQualityBadge';

type Props = { current?: any; isDarkMode: boolean };

const titleCase = (value: any) => {
  const text = String(value || '').replace(/_/g, ' ').trim();
  return text ? text.replace(/\b\w/g, (m) => m.toUpperCase()) : '';
};

export default function WaterIntelCurrentPanel({ current, isDarkMode }: Props) {
  const available = !!current?.available;
  const speed = Number(current?.speedKnots);
  const direction = String(current?.directionLabel || '').trim();
  const phase = titleCase(current?.phase);
  const trend = titleCase(current?.trend);
  const station = String(current?.sourceStationName || '').trim();
  const context = [phase, trend].filter(Boolean).join(' · ');

  return (
    <section
      className="min-w-0 rounded-[14px] border p-2.5 sm:rounded-[15px] sm:p-3"
      style={{
        background: isDarkMode ? 'rgba(11,23,39,0.88)' : 'rgba(255,255,255,0.68)',
        borderColor: isDarkMode ? 'rgba(103,216,232,0.12)' : 'rgba(69,127,157,0.10)',
      }}
    >
      <div className="flex items-center justify-between gap-2">
        <div
          className="text-[8px] font-black uppercase tracking-[0.14em]"
          style={{ color: isDarkMode ? '#66D9E8' : '#24779B' }}
        >
          Current
        </div>
        <WaterIntelQualityBadge quality={current?.quality} isDarkMode={isDarkMode} />
      </div>

      {available ? (
        <>
          <div
            className="mt-1.5 truncate text-[18px] font-black leading-none sm:text-[19px]"
            style={{ color: isDarkMode ? '#F2F6FC' : '#2D3957' }}
          >
            {Number.isFinite(speed) ? speed.toFixed(speed < 1 ? 2 : 1) : '—'} kt
          </div>

          {direction ? (
            <div className="mt-1 truncate text-[10px] font-black opacity-80">{direction}</div>
          ) : null}

          {context ? (
            <div className="mt-1 truncate text-[8.5px] font-bold opacity-50">{context}</div>
          ) : station ? (
            <div className="mt-1 truncate text-[8.5px] font-bold opacity-45">NOAA · {station}</div>
          ) : null}
        </>
      ) : (
        <div
          className="mt-1.5 text-[11px] font-black leading-tight"
          style={{ color: isDarkMode ? '#AEB8C9' : '#756A60' }}
        >
          No coverage
        </div>
      )}
    </section>
  );
}
